import Vue from "vue";
import BaseCard from "@/components/base/Card";
import BaseInformation from "@/components/base/Information";

Vue.component("base-card", BaseCard);
Vue.component("base-info", BaseInformation);



// WEBPACK FOOTER //
// ./src/plugins/base.js